import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CalendarList from './components/CalendarList';

const { Cell } = ResponsiveGrid;

const Calendar = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="行事曆列表"
        // description="行事曆列表"
        breadcrumbs={[
          {
            name: '行事曆',
          },
          {
            name: '行事曆列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CalendarList />
    </Cell>
  </ResponsiveGrid>
);

export default Calendar;
